import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetimeline from '@growthbunker/vuetimeline'
import { vsCollapse, vsIcon } from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css'

Vue.config.productionTip = false
Vue.use(vuetimeline, {
  theme: 'dark'
})
Vue.use(vsCollapse)
Vue.use(vsIcon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
